import permission from './module/permisson'
import throttle from './module/throttle'

const directives = {
  permission,
  throttle
}

export default directives
